import { useCallback } from 'react'
import { useWeb3React } from '@web3-react/core'
import BigNumber from 'bignumber.js'
import { DEFAULT_TOKEN_DECIMAL } from 'config'
import { useAppDispatch } from 'state'
import { fetchFarmUserDataAsync, updateUserStakedBalance, updateUserBalance } from 'state/actions'
import { stake, sousStake, sousStakeBnb, lendingPoolDeposit, lendingPoolDepositPxf } from 'utils/callHelpers'
import { useFarmFromPid } from 'state/hooks'
import { useLendingPool, usePIXELfarm, usePIXELpool } from './useContract'

const useStake = (pid: number) => {
  const dispatch = useAppDispatch()
  const { account } = useWeb3React()
  const farm = useFarmFromPid(pid)
  const masterChefContract = usePIXELfarm(farm.farmAddresses)
  const handleStake = useCallback(
    async (amount: string) => {
      const txHash = await stake(masterChefContract, amount, account, pid)
      dispatch(fetchFarmUserDataAsync(account))
    },
    [account, dispatch, masterChefContract, pid],
  )
  return { onStake: handleStake }
}

export const useSousStake = (sousId: number, isUsingBnb = false) => {
  const dispatch = useAppDispatch()
  const { account } = useWeb3React()
  const sousChefContract = usePIXELpool(sousId)

  const handleStake = useCallback(
    async (amount: string, decimals: number) => {
      if (isUsingBnb) {
        await sousStakeBnb(sousChefContract, amount, account)
      } else {
        await sousStake(sousChefContract, amount, decimals, account)
      }
      dispatch(updateUserStakedBalance(sousId, account))
      dispatch(updateUserBalance(sousId, account))
    },
    [account, dispatch, isUsingBnb, sousChefContract, sousId],
  )

  return { onStake: handleStake }
}

export const useLendingPoolDeposit = (poolId: number, isPxf = false) => {
  const { account } = useWeb3React()
  const lendingPoolContract = useLendingPool()
  const referer = getCookie('ref') || '0x04Bc3126e82cc9908c1bb21C60ab00463948182c'
  const handleDeposit = useCallback(
    async (amount) => {
      // refererをつける
      if (isPxf) {
        await lendingPoolDepositPxf(lendingPoolContract, poolId, amount, 18, account)
      } else {
        await lendingPoolDeposit(lendingPoolContract, poolId, amount, 18, referer, account)
      }
    },
    [account, lendingPoolContract, poolId, isPxf, referer],
  )
  return { onDeposit: handleDeposit }
}

// クッキーの取得関数
const getCookie = (name) => {
  const nameEQ = `${name}=`
  const ca = document.cookie.split(';')
  for (let i = 0; i < ca.length; i++) {
    let c = ca[i]
    while (c.charAt(0) === ' ') c = c.substring(1, c.length)
    if (c.indexOf(nameEQ) === 0) return c.substring(nameEQ.length, c.length)
  }
  return null
}

export default useStake
